const ALERT_TYPES = {
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
};

export default ALERT_TYPES;
